import { MenuItem, TextField } from '@mui/material'
import { useFormikContext } from 'formik'

import {
  ECampaignTemplateFormKeys,
  TCreateCampaignTemplateForm,
  TCreateTemplateFromCampaignForm,
} from '~/features/admin/models'

export type TProps = {
  isLoading?: boolean
}

export default function CampaignTemplateOwnerType({
  isLoading = false,
}: TProps) {
  const formik = useFormikContext<
    TCreateCampaignTemplateForm | TCreateTemplateFromCampaignForm
  >()
  const { values, errors, handleChange } = formik
  return (
    <TextField
      required
      select
      fullWidth
      size="small"
      label="Owner type"
      name={ECampaignTemplateFormKeys.ownerType}
      value={values[ECampaignTemplateFormKeys.ownerType] as string}
      error={Boolean(errors[ECampaignTemplateFormKeys.ownerType])}
      helperText={errors[ECampaignTemplateFormKeys.ownerType]}
      onChange={handleChange}
      disabled={isLoading}
    >
      <MenuItem value="system">System</MenuItem>
    </TextField>
  )
}
